import React from 'react'
import {Modal, Row} from 'antd'
import DepartmentForm from '../../../../components/Project/Resources/Departments/DepartmentsForm'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'

function DepartmentModal(props) {
  const {
    visible,
    modalType,
    submitting,
    submit,
    update,
    formRef,
    onCancel,
    removing,
    remove,
  } = props
  return (
    <Modal
      visible={visible}
      title={'Department'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          remove={remove}
          removing={removing}
          submit={submit}
          update={update}
          submitting={submitting}
          title={'Department'}
          isNew={modalType === 'new'}
          isEdit={modalType !== 'new'}
        />
      }
      width={'75%'}>
      <Row>
        <DepartmentForm ref={formRef} {...props} />
      </Row>
    </Modal>
  )
}

DepartmentModal.propTypes = {}
DepartmentModal.defaultProps = {}

export default DepartmentModal
